import { checkPrivacyAndStartMeasurement } from "../../../features/measurement/measurementSlice";
import { updatePage } from "../../../features/pageManager/pageManagerSlice";
import { PageKey } from "../../../features/pageManager/pageState";
import { AppThunk } from "../../../store";

export const startMeasurement3 = (): AppThunk => (dispatch, getState) => {    
    if (dispatch(checkPrivacyAndStartMeasurement())) {
        dispatch(updatePage(PageKey.Measurement));
    }
}